import { ObjectFactory } from '@/config/objectFactory';
import { User } from '@/types/entity';
import { ApiRequest } from '@/types/request';
import { ApiResponse } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { IUserService } from '../iUserService';

export class UserService implements IUserService {

    public async refreshToken(clientId: string, baseURL: string): Promise<ApiResponse<string>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_USERS}/refreshToken?clientId=${clientId}`,
        };
        const response = await iHttpService.put<string>(apiRequest);
        return response;
    }

    public async getUserById(id: string, baseURL: string): Promise<ApiResponse<User>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_USERS}/${id}`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.get<User>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }
}
